"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 19h14V5H5zM15 7h2v2h-2zm0 4h2v2h-2zm-4-4h2v2h-2zm0 4h2v2h-2zM7 7h2v2H7zm0 4h2v2H7z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7 7h2v2H7zm0 4h2v2H7z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3zm16 16H5V5h14z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M11 7h2v2h-2zm4 4h2v2h-2zm-4 0h2v2h-2zm4-4h2v2h-2z"
}, "3")], 'MarginTwoTone');